import React, { useState, useEffect, useRef } from 'react';
import '../CSS/Navbar.css';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const deleteCookie = (cookieName) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

const Navbar = ({ setCurrentPage, handleLogout }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userSession = Cookies.get('userSession');
    if (userSession) {
      const parsedUser = JSON.parse(userSession);
      setUserInfo(parsedUser?.data?.user_info); // Correctly access user_info
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = (event) => {
    event.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogoutClick = () => {
    deleteCookie('userSession');
    handleLogout(); 
    navigate('/');
  };

  return (
    <nav className="navbar">
      <h1 className="navbar-logo" onClick={() => setCurrentPage('Dashboard')}>
        X Vector PR
      </h1>
      <div className="user-tab" onClick={toggleDropdown}>
        <i className="fas fa-user user-icon"></i>
        <span className="user-name">{userInfo ? userInfo.name : 'Guest'}</span>
        {dropdownOpen && (
          <div className="dropdown" ref={dropdownRef}>
            {userInfo ? (
              <>
                <p><strong>Name:</strong> {userInfo.name}</p>
                <p><strong>Email:</strong> {userInfo.email}</p>
                <p><strong>Role:</strong> {userInfo.role}</p>
              </>
            ) : (
              <p>No user data available</p>
            )}
            <button className="logout-btn" onClick={handleLogoutClick}>
              <i className="fas fa-sign-out-alt"></i> Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
